import { string } from 'prop-types';

export default {
    name: string.isRequired,
    // Derived from `name` (the CMS model has no slug field) and only present
    // where a category needs to be linked - see TMUtils/blogPaths.
    slug: string,
    basePath: string
};
